<template>
  <div class="min-h-screen bg-gray-50 dark:bg-neutral-900">
    <Breadcrumb :items="[{ title: 'Hizmetlerimiz', path: '/services' }]" />
    
    <!-- Hero Section -->
    <div class="relative bg-gradient-to-r from-primary to-primary/80 h-[300px] overflow-hidden">
      <div class="absolute inset-0">
        <div class="absolute inset-0 bg-[url('/assets/images/pattern-grid.svg')] opacity-10"></div>
        <div class="absolute inset-0 bg-gradient-to-b from-black/10 to-transparent"></div>
      </div>
      <div class="relative container mx-auto px-4 h-full flex items-center">
        <div class="max-w-2xl text-white">
          <h1 class="text-4xl md:text-5xl font-bold mb-4">{{ pageData.title }}</h1>
          <p class="text-xl opacity-90">{{ pageData.description }}</p>
        </div>
      </div>
    </div>

    <!-- Services Grid -->
    <div class="py-16">
      <div class="container mx-auto px-4">
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-8">
          <NuxtLink v-for="service in services" 
                    :key="service.id" 
                    :to="service.path" 
                    class="group">
            <div class="bg-white dark:bg-neutral-800 rounded-2xl p-8 shadow-lg transition-all duration-300 hover:shadow-xl relative overflow-hidden">
              <div class="absolute top-0 left-0 w-2 h-full bg-primary transform scale-y-0 group-hover:scale-y-100 transition-transform duration-300 origin-top"></div>
              <div class="relative">
                <div class="w-16 h-16 bg-primary/10 rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                  <i :class="['fas', service.icon, 'text-primary text-2xl']"></i>
                </div>
                <h3 class="text-2xl font-semibold text-gray-900 dark:text-white mb-4">{{ service.title }}</h3>
                <p class="text-gray-600 dark:text-gray-400 mb-6">{{ service.description }}</p>
                <div class="flex items-center text-primary">
                  <span class="font-medium">{{ service.linkText }}</span>
                  <i class="fas fa-arrow-right ml-2 group-hover:translate-x-2 transition-transform duration-300"></i>
                </div>
              </div>
            </div>
          </NuxtLink>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
// Sayfa meta verisi
definePageMeta({
  title: 'Hizmetlerimiz'
})

// Sayfa verileri (Normalde API'den gelecek)
const pageData = {
  title: 'Hizmetlerimiz',
  description: 'Size özel profesyonel çözümler sunuyoruz'
}

// Hizmet verileri (Normalde API'den gelecek)
const services = [
  {
    id: 1,
    title: 'Kuluçka Merkezi',
    description: 'Girişimcilere özel ofis alanları, mentorluk ve networking imkanları sunuyoruz.',
    icon: 'fa-rocket',
    path: '/services',
    linkText: 'Detaylı Bilgi',
    order: 1
  },
  {
    id: 2,
    title: 'Ar-Ge Destekleri',
    description: 'Ar-Ge projeleriniz için finansal destekler ve teşvikler sağlıyoruz.',
    icon: 'fa-flask',
    path: '/services',
    linkText: 'Detaylı Bilgi',
    order: 2
  },
  {
    id: 3,
    title: 'Danışmanlık',
    description: 'İş geliştirme, patent ve fikri mülkiyet hakları konularında danışmanlık hizmetleri.',
    icon: 'fa-comments',
    path: '/services',
    linkText: 'Detaylı Bilgi',
    order: 3
  },
  {
    id: 4,
    title: 'Kira Hizmet Bedelleri',
    description: 'Teknopark bünyesindeki ofis ve hizmetlere ait güncel fiyat listesi.',
    icon: 'fa-file-invoice-dollar',
    path: '/services',
    linkText: 'Detaylı Bilgi',
    order: 4
  }
]
</script> 